import { render, staticRenderFns } from "./ObjViewer.vue?vue&type=template&id=2a1bcf2c&scoped=true"
import script from "./ObjViewer.vue?vue&type=script&lang=js"
export * from "./ObjViewer.vue?vue&type=script&lang=js"
import style0 from "./ObjViewer.vue?vue&type=style&index=0&id=2a1bcf2c&prod&scoped=true&lang=css"
import style1 from "./ObjViewer.vue?vue&type=style&index=1&id=2a1bcf2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bcf2c",
  null
  
)

export default component.exports